import { Route, Routes } from 'react-router-dom';
import paths from './page-config/paths';
import ErrorWL from './pages/errorWL';
import Index from './pages/index';
import Login from './pages/login';
import PageNotFound from './pages/pageNotFound';
import { RemoveTrailingSlash } from './pages/RemoveTrailingSlash';
import Version from './pages/version';
function App() {
    // const changeLanguage = (lng: any): void => {
    //     i18n.changeLanguage(lng);
    // };
    return (
        <>
            <RemoveTrailingSlash />
            <Routes>
                <Route
                    path="/"
                    element={<Login />}
                />
                <Route
                    path="/login"
                    element={<Login />}
                />
                <Route
                    path="/version"
                    element={<Version />}
                />
                <Route
                    path="/error-wl"
                    element={<ErrorWL />}
                />
                {paths &&
                    paths?.map((path) => {
                        return (
                            <Route
                                key={path}
                                path={path}
                                element={<Index />}
                            />
                        );
                    })}
                <Route
                    path="*"
                    element={<PageNotFound />}
                />
            </Routes>
        </>
    );
}

export default App;
